import styled, { keyframes } from "styled-components";
import { mainColor, additionalColor } from "../../root/global";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
`;

const glow = keyframes`
  0%, 100% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
`;

export const SpinnerOverlay = styled.div`
  height: 90vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  animation: ${fadeIn} 0.35s ease-out;
`;

export const SpinnerRing = styled.div`
  position: relative;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 3px solid rgba(40, 52, 74, 0.12);
  border-top-color: ${mainColor};
  border-right-color: ${additionalColor};
  animation: ${spin} 0.9s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    margin: -4px 0 0 -4px;
    border-radius: 50%;
    background: ${additionalColor};
    animation: ${pulse} 1.8s ease-in-out infinite;
  }
`;

export const BrandMark = styled.div`
  font-family: "Red Hat Display", sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: ${mainColor};
  animation: ${glow} 1.8s ease-in-out infinite;

  span {
    color: ${additionalColor};
  }
`;
